"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const immutable_1 = require("immutable");
const utils_1 = require("../utils");
const types = require("./types");
// eslint-disable-next-line @rushstack/typedef-var
const errorMessage = utils_1.createReducer(immutable_1.Map())({
    [types.UPDATE_FAILURE]: (s, action) => s.set(action.pluginName, action.errorMessage),
    [types.UPDATE_REQUEST]: (s, action) => s.set(action.pluginName, null),
    [types.UPDATE_SUCCESS]: (s, action) => s.set(action.pluginName, null)
});
// eslint-disable-next-line @rushstack/typedef-var
const isProcessing = utils_1.createReducer(immutable_1.Map())({
    [types.UPDATE_FAILURE]: (s, action) => s.set(action.pluginName, false),
    [types.UPDATE_REQUEST]: (s, action) => s.set(action.pluginName, true),
    [types.UPDATE_SUCCESS]: (s, action) => s.set(action.pluginName, false)
});
// eslint-disable-next-line @rushstack/typedef-var
const state = utils_1.createReducer(immutable_1.Map())({
    [types.UPDATE_SUCCESS]: (s, action) => {
        return s.set(action.pluginName, action.data);
    }
});
exports.default = redux_1.combineReducers({
    errorMessage,
    isProcessing,
    state
});
//# sourceMappingURL=reducers.js.map